"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNull = void 0;
const parseNull = (_schema) => {
  return "z.null()";
};
exports.parseNull = parseNull;
